module.exports = __webpack_public_path__ + "e7e3139a1b5d39725e5d1a55297207b5.png";